{"schemaVersion":1,"release":{"version":"1.0.6","build":148,"url":"https://cdn.gab.ai/macos/updates/installers/Gab-AI-1.0.6-148.dmg","sha256":"8306f15bb0e089427b9104f88cd0cf9e7806de6e9f9d543c25179d14d0dd362d","size":29002011}}
